export default class CourierExpressDelivery {
    reMark: string;
    shipment: string;
    courierCompanyId?: number;
    storageTime: Date;
    id: number;
    warehouseInfoId: number;
    isEnable: boolean;
    courierCompany: string;
}